export const AFFILIATE_TYPE = {
  KOC: 1,
  BUSINESS: 2,
} as const;

export type AffiliateType = typeof AFFILIATE_TYPE[keyof typeof AFFILIATE_TYPE];
export type AffiliatePostFilter = 'all' | 'live' | 'reel';
export type AffiliateListTab = 'post' | 'partner';

export interface AffiliatePost {
  id: string;
  pageId: string;
  pageName: string;
  message: string;
  postType: 'live' | 'reel' | 'post';
  picture: string;
  createdAt: number;
}

export interface AffiliateSharedPost {
  id: string;
  pageId: string;
  pageName: string;
  postId: string;
  message: string;
  partnerName: string;
  startTime: number;
  endTime: number;
}

export interface AffiliatePartner {
  id: string;
  connectionId: string;
  name: string;
  sharedPostCount: number;
}

export interface AffiliateListState {
  next: string | false;
  loading: boolean;
  loaded: boolean;
}

export interface IAffiliateConnectItem {
  id: string;
  business_seller_id: string;
  business_seller_name: string | null;
  business_partner_id: string;
  business_partner_name: string | null;
  connected_post_count: number;
  shared_post_count: number;
  status: number;
  createdAt: number;
}

export interface IAffiliateSharedPostItem {
  id: string;
  fromBusinessId: string;
  fromBusinessName: string | null;
  toBusinessId: string;
  toBusinessName: string | null;
  fromPageId: string;
  fromPageName: string | null;
  fromPostId: string;
  post?: {
    message?: string;
    story?: string;
  };
  startTime: string | number;
  endTime: string | number;
  createdAt: string | number;
}

export interface IAffiliateListData<T> {
  items: T[];
  next: unknown[] | false;
}

export interface IAffiliateSettingData {
  setting: {
    affiliate_sharing_connect_code: string;
    businessId: string;
    status: number;
  };
}

export interface IAffiliateListParams {
  type: AffiliateType;
  size?: number;
  next?: string;
}

export interface IAffiliateSaveSharePostParams {
  sellerIds: string[];
  postIds: string[];
  startTime: number;
  endTime: number;
}

export interface IAffiliateUpdateSharePostParams {
  id: string;
  startTime: number;
  endTime: number;
}

export interface IAffiliateFeedParams {
  pageId: string;
  channel: number;
  after?: string;
  next?: string;
  limit?: number;
  postType?: 1 | 2;
}

export interface IAffiliateFeedItem {
  id?: string;
  message?: string;
  story?: string;
  full_picture?: string;
  created_time: string;
  is_hidden?: boolean;
  isLive?: number;
  description?: string;
  post_id?: string;
  picture?: string;
}

export interface IAffiliateFeedData {
  items: IAffiliateFeedItem[];
  next: unknown[] | false;
  paging?: {
    cursors?: {
      before?: string;
      after?: string;
    };
  } | null;
}

export interface IAffiliateConnectData {
  connection: {
    id: string;
    business_seller_id: string;
    business_partner_id: string;
    status: number;
    createdAt: number;
    createdById: string;
  };
}
